export const INVITATION_REQUEST = "UI/INVITATION/REQUEST";
export const INVITATION_REQUEST_FAILURE = "UI/INVITATION/REQUEST_FAILURE";
export const INVITATION_REQUEST_SUCCESS = "UI/INVITATION/REQUEST_SUCCESS";
export const INVITATION_ACCEPT_REQUEST = "UI/INVITATION_ACCEPT/REQUEST";
export const INVITATION_ACCEPT_REQUEST_FAILURE =
  "UI/INVITATION_ACCEPT/REQUEST_FAILURE";
export const INVITATION_ACCEPT_REQUEST_SUCCESS =
  "UI/INVITATION_ACCEPT/REQUEST_SUCCESS";
